<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [isBlur]="isBlur"
  [errors]="question.errors"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [dirty]="dirty"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>
<ng-container [formGroup]="formGroup">
  <ion-item>
    <ion-textarea
      [formControlName]="question.key"
      [attr.disabled]="question.disabled"
      [attr.readonly]="question.readonly"
      (ionFocus)="onFocus()"
      (ionInput)="onInput()"
      (ionBlur)="onBlur()"
      [placeholder]="question.placeholder | translate"
      (ionChange)="onChange()"
    >
    </ion-textarea>
  </ion-item>
</ng-container>
